import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c('template-text-field', {
    attrs: {
      "customParameters": _vm.customParameters,
      "twin": _vm.twins,
      "disable-twin-fields": _vm.widgetType === 'empty',
      "label": _vm.$t('Dashboards.components.widgetEditDialog.tabs.general.inputs.title.label'),
      "data-cy": "widget-title-template"
    },
    model: {
      value: _vm.widgetTitle,
      callback: function ($$v) {
        _vm.widgetTitle = $$v;
      },
      expression: "widgetTitle"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('widget-type-select', {
    model: {
      value: _vm.widgetType,
      callback: function ($$v) {
        _vm.widgetType = $$v;
      },
      expression: "widgetType"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('widget-size-select', {
    model: {
      value: _vm.widgetSize,
      callback: function ($$v) {
        _vm.widgetSize = $$v;
      },
      expression: "widgetSize"
    }
  })], 1)], 1), _vm.widgetType !== 'twin-table' ? _c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "data-cy": "widget-min-height",
      "type": "number",
      "clearable": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetEditDialog.tabs.general.inputs.minHeightPx.label')
    },
    model: {
      value: _vm.minHeightPx,
      callback: function ($$v) {
        _vm.minHeightPx = _vm._n($$v);
      },
      expression: "minHeightPx"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "data-cy": "widget-hide-header",
      "color": _vm.color,
      "label": _vm.$t('Dashboards.components.widgetEditDialog.tabs.general.inputs.hideHeader.label')
    },
    model: {
      value: _vm.hideHeader,
      callback: function ($$v) {
        _vm.hideHeader = $$v;
      },
      expression: "hideHeader"
    }
  })], 1), _c(VCol, [_c(VSwitch, {
    attrs: {
      "data-cy": "widget-borderless",
      "color": _vm.color,
      "label": _vm.$t('Dashboards.components.widgetEditDialog.tabs.general.inputs.borderless.label')
    },
    model: {
      value: _vm.borderless,
      callback: function ($$v) {
        _vm.borderless = $$v;
      },
      expression: "borderless"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };